import {
  Map,
  Target,
  Crosshair,
  Play,
  Settings,
  Info,
  RadarIcon,
  RocketIcon,
  MapIcon,
  SquareTerminal,
  UserIcon,
  SquareArrowRightIcon,
  CameraIcon,
} from "lucide-react";
import type { NavItem, NavGroup, SettingsMenu, PreferencesMenu } from "./types";
import {
  IconDeviceComputerCamera,
  IconRadar,
  IconRocket,
} from "@tabler/icons-react";

export const mainNavItems: NavItem[] = [
  {
    id: "pdar",
    label: "PDAR",
    to: "/map/pdar",
    icon: IconRadar,
  },
  {
    id: "hira",
    label: "HIRA",
    to: "/map/hira",
    icon: IconDeviceComputerCamera,
  },
  {
    id: "skopa",
    label: "SKOPA",
    to: "/map/skopa",
    icon: IconRocket,
  },
];

export const secondaryNavItems: NavGroup[] = [
  {
    id: "Map",
    label: "Map",
    items: [
      {
        id: "settings-map-position",
        label: "Map Position",
        to: "/map/skopa",
      },
    ],
  },
];

export const modulesNavItems: SettingsMenu[] = [
  {
    title: "Skopa",
    icon: RocketIcon,
    isActive: true,
    items: [
      {
        title: "View",
        url: "/settings/skopa/view",
      },
      {
        title: "Config",
        url: "/settings/skopa/config",
      },
      {
        title: "Logs",
        url: "/settings/skopa/logs",
      },
      {
        title: "Docs",
        url: "/settings/skopa/docs",
      },
    ],
  },
  // {
  //   title: "PDAR",
  //   icon: RadarIcon,
  //   isActive: true,
  //   items: [
  //     {
  //       title: "Stations",
  //       url: "/settings/pdar/stations",
  //     },
  //     {
  //       title: "AoAs",
  //       url: "/settings/pdar/aoas",
  //     },
  //     {
  //       title: "Docs",
  //       url: "/settings/pdar/docs",
  //     },
  //   ],
  // },
];

export const preferencesNavItems: PreferencesMenu[] = [
  {
    name: "Map",
    url: "/settings/map",
    icon: MapIcon,
  },
  {
    name: "Admin",
    url: "/settings/admin",
    icon: UserIcon,
  },
  {
    name: "Source",
    url: "/settings/source",
    icon: SquareArrowRightIcon,
  },
];
